import { Registry } from '@amzn/awscat-cookie-management';

const applicationGrouping = 'applicationGrouping:waveCapacity';
const dashboard = 'dashboard:portfolio:';
const experimental = 'flags:experimental';
const recentPortfolios = 'recent-portfolios:portfolios';

export const ShortbreadRegistry: Registry = {
    'state': { category: 'essential' },
    [applicationGrouping]: { category: 'functional' },
    [dashboard]: { category: 'functional' },
    [experimental]: { category: 'functional' },
    [recentPortfolios]: { category: 'functional' },
};
